import { render, staticRenderFns } from "./BankVerification.vue?vue&type=template&id=386e4676&scoped=true"
import script from "./BankVerification.vue?vue&type=script&lang=js"
export * from "./BankVerification.vue?vue&type=script&lang=js"
import style0 from "./BankVerification.vue?vue&type=style&index=0&id=386e4676&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386e4676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386e4676')) {
      api.createRecord('386e4676', component.options)
    } else {
      api.reload('386e4676', component.options)
    }
    module.hot.accept("./BankVerification.vue?vue&type=template&id=386e4676&scoped=true", function () {
      api.rerender('386e4676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/BankVerification/BankVerification.vue"
export default component.exports